import { useState } from "react";

import useUpsertBrand from "../../../../clients/brands/useUpsertBrand";
import Brand from "../../domain/Brand";

export default function useBrandWriter(brand: Brand, onSave: (brand: Brand) => void) {
    const [error, setError] = useState<string | null>(null);
    const [info, setInfo] = useState<string | null>(null);
    const [record] = useUpsertBrand(brand);

    async function save(event?: { preventDefault?: () => void }): Promise<boolean> {
        event?.preventDefault?.();
        setError(null);
        setInfo(null);

        try {
            const result = await record();

            onSave?.(
                brand.change({ id: result.data.upsertBrand.id })
            );
            setInfo("Brand is successfully saved.");
            setTimeout(() => setInfo(null), 10000);
            return true;
        } catch (e) {
            const error = e as { graphQLErrors?: { message?: string }[], message?: string };
            const message = error?.graphQLErrors?.[0]?.message ?? error?.message ?? "Unknown error";

            if (message.includes("E11000") && message.includes("legacyAlias")) {
                setError("Legacy alias must be unique — another brand already uses this value.");
            } else if (message.includes("E11000") && message.includes("legacyID")) {
                setError("Legacy ID must be unique — another brand already uses this value.");
            } else if (message.includes("E11000")) {
                setError("Duplicate value — another brand already uses one of these unique fields.");
            } else {
                setError(message);
            }
            return false;
        }
    }

    return { save, error, info };
}
